!function ($) {

  $(function(){

    var $window = $(window)
    
    // side bar
    $('.ntry-sidenav').affix({
      offset: {
        top: function () { return $window.width() <= 980 ? 193 : 163 }
      , bottom: 0
      }
    })
  })
}(window.jQuery)